import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { SectoresOrganizacionalesService } from '../../services/sectores-organizacionales.service';

@Component({
  selector: 'app-sectores-organizacionales-tipo',
  templateUrl: './sectores-organizacionales-tipo.component.html',
  styleUrls: ['./sectores-organizacionales-tipo.component.css']
})
export class SectoresOrganizacionalesTipoComponent implements OnInit {

  listado: Catalogo[] = [];

  @Output()
  itemSelected = new EventEmitter<any>();

  @Output() backTo = new EventEmitter<number>();

  @Input() title: string;
  @Input() hijo: number;

  @Input() sector: boolean;
  @Input() ocupacion: boolean;
  @Input() nivel: boolean;

  constructor(private service: SectoresOrganizacionalesService) {

  }

  ngOnInit(): void {
    if (this.sector && !this.ocupacion && !this.nivel) {
      this.getSectores();      
    } else if (this.ocupacion && !this.nivel && !this.sector) {
      //this.getOcupacion();
      this.getNivelXSector();
    } else if (this.nivel && !this.ocupacion && !this.sector) {
      this.getNivel();
    }
  }

  async getSectores() {
    try {
      let get: any[];
      get = await this.service.getSectoresOrganizacionales();
      get.forEach(element => {
        let lst: Catalogo = {
          id: element.id,
          descripcion: element.nbSectorProductivo,
          activo: element.fgActivo,
          nombreImagen: element.nbImagen
        }
        this.listado.push(lst);
      });
    } catch (error) {
      console.log(error);
    }

    this.listado.sort((a, b) => {
      const nameA = a.descripcion.toUpperCase(); // ignore upper and lowercase
      const nameB = b.descripcion.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      // names must be equal
      return 0;
    });
  }

  async getNivelXSector() {
    try {
      let get: any[];
      get = await this.service.getNivelesXSectorById(this.hijo);
      get.forEach(element => {
        let lst: Catalogo = {
          id: element.id,
          descripcion: element.nbNivelesOcupacionales,
          activo: element.fgActivo,
          nombreImagen: element.nbImagen
        }
        this.listado.push(lst);
      });
    } catch (error) {
      console.log(error);
    }
    this.listado.sort((a, b) => {
      const nameA = a.descripcion.toUpperCase(); // ignore upper and lowercase
      const nameB = b.descripcion.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  }



  async getOcupacion() {
    try {
      let get: any[];
      get = await this.service.getOcupaconesBySector(this.hijo);
      let lst: any[] = Object.values(get)[0];
      lst.forEach(element => {
        let lst: Catalogo = {
          id: element.id,
          descripcion: element.nbOcupaciones,
          activo: element.fgActivo,
          nombreImagen: element.nbImagen
        }
        this.listado.push(lst);
      });
    } catch (error) {
      console.log(error);
    }
  }

  async getNivel() {
    try {
      let get: any[];
      get = await this.service.getNivelesById(this.hijo);
      let lst: any[] = Object.values(get)[0];
      lst.forEach(element => {
        let lst: Catalogo = {
          id: element.id,
          descripcion: element.nbNivelesOcupacionales,
          activo: element.fgActivo,
          nombreImagen: element.nbImagen
        }
        this.listado.push(lst);
      });
    } catch (error) {
      console.log(error);
    }
  }

  async getSectoresByEstandar(event: any) {
    //obtiene informacion del buscador
  }

  sectorByID(element) {
    let json = {
      element: element,
      padre: this.hijo,
      lastTitle: this.title
    };
    this.itemSelected.emit(json);
  }

  back() {
    let flags: any = {
      nivel: false,
      ocupacion: false,
      sector: false,
    };
    if (this.ocupacion && !this.nivel && !this.sector) {
      flags.sector = true;
    } else if (this.nivel && !this.ocupacion && !this.sector) {
      flags.ocupacion = true;
    }
    this.backTo.emit(flags);
  }

  home() {
    window.location.reload();
  }

  verificaLongitud() {
    if (this.listado !== undefined) {
      var aux = 0;
      for (var i = 0; i < this.listado.length; i++) {
        aux = i;
        if (i === 0 || i === 3 || i === 6 || i === 9 || i === 12 || i === 15 || i === 18) {
          if (this.listado[aux] !== undefined && this.listado[aux + 1] !== undefined && this.listado[aux + 2] !== undefined) {
            if (this.listado[aux].descripcion.length <= 34 && this.listado[aux + 1].descripcion.length <= 34 && this.listado[aux + 2].descripcion.length <= 34) {
              var el = document.getElementById("" + i);
              if (el !== null)
                el.style.height = '70px';
              var el = document.getElementById("" + (i + 1));
              if (el !== null)
                el.style.height = '70px';
              var el = document.getElementById("" + (i + 2));
              if (el !== null)
                el.style.height = '70px';
            }
          }
        }
      }
    }
  }

  ngAfterViewChecked() {
    this.verificaLongitud();
  }

}


export interface Catalogo {
  id: Number;
  descripcion: String;
  activo: Boolean;
  nombreImagen: String;
}
